import React, {useEffect, useRef, useState} from "react";
import {Tabs} from "antd";
import {ExpandSearch} from "components/common";

import {fields as fieldsInit, items} from "./config";
import {FORMAT_TIME, TT_DON_KINH, tabKeys} from "types/enums";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader} from "redux/reducer/common";
import dayjs from "dayjs";
import {
  getListPatientAPI,
  setActiveTabPresciption,
  setExpandRef,
  setIdBill,
  setSearchForm,
} from "redux/reducer/glassKiot";
import {formatDateToString} from "helper/common";
import {getListStore} from "redux/reducer/glassStore";
import {listTT_Don_Kinh} from "data/list";

const ListPrescription = () => {
  const activeKey = useAppSelector(state => state.common.activeTab);
  const activeTabPrescription = useAppSelector(
    state => state.glassKiot.activeTabPresciption
  );
  const [inputFields, setInputFields] = useState(fieldsInit);
  const dispatch = useAppDispatch();
  const expandRef = useRef(null);
  const listStore = useAppSelector(state => state.glassStore.listStore);
  useEffect(() => {
    dispatch(getListStore());
    dispatch(getListPatientAPI(""));
  }, []);
  useEffect(() => {
    const setOptionsStore = listStore => {
      const options = listStore.map(e => ({
        label: e?.name,
        value: e?.id,
        key: e?.id,
      }));

      fieldsInit.find(e => e.name == "storeId").options = options;

      setInputFields([...fieldsInit]);
    };
    setOptionsStore(listStore);
  }, [listStore]);

  useEffect(() => {
    if (activeKey == tabKeys.GLASSES.TAB_1) {
      dispatch(setButtonsHeader([]));
      dispatch(setIdBill(null));
    }
  }, [activeKey]);
  useEffect(() => {
    dispatch(setExpandRef(expandRef?.current));
  }, [expandRef?.current]);
  useEffect(() => {
    const setOptionsStatus = () => {
      let listTT;
      if (activeTabPrescription == tabKeys.GLASSES.LIST_1) {
        listTT = listTT_Don_Kinh.filter(e => e.value == TT_DON_KINH.CHUA_BAN);
      } else {
        listTT = listTT_Don_Kinh.filter(e => e.value != TT_DON_KINH.CHUA_BAN);
      }

      const options = listTT.map(e => ({
        label: e?.label,
        value: e?.value,
        key: e?.value,
      }));

      fieldsInit.find(e => e.name == "status").options = options;

      setInputFields([...fieldsInit]);
    };
    setOptionsStatus();
  }, [activeTabPrescription]);
  useEffect(() => {
    const setFieldsValue = () => {
      expandRef?.current?.resetFields();
      if (activeTabPrescription == tabKeys.GLASSES.LIST_2) {
        expandRef?.current?.setFieldValue("start", dayjs());
        expandRef?.current?.setFieldValue("end", dayjs());
        expandRef?.current?.setFieldValue("ngayBanTu", dayjs());
        expandRef?.current?.setFieldValue("ngayBanDen", dayjs());
        dispatch(
          setSearchForm({
            ["start"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
            ["end"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
            ["ngayBanTu"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
            ["ngayBanDen"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
          })
        );
      } else if (activeTabPrescription == tabKeys.GLASSES.LIST_1) {
        expandRef?.current?.setFieldValue("start", dayjs());
        expandRef?.current?.setFieldValue("end", dayjs());
        dispatch(
          setSearchForm({
            ["start"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
            ["end"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
            ["storeId"]: null,
          })
        );
      } else {
        // expandRef?.current?.setFieldValue("thoiGianTra", dayjs());
        // dispatch(
        //   setSearchForm({
        //     ["thoiGianTra"]: formatDateToString(dayjs(), FORMAT_TIME.dayFull),
        //   })
        // );
      }
    };
    setFieldsValue();
  }, [activeTabPrescription]);

  useEffect(() => {
    const setFieldsShow = () => {
      fieldsInit.find(e => e.name == "storeId").hide =
        activeTabPrescription != tabKeys.GLASSES.LIST_2;
      setInputFields([...fieldsInit]);
    };
    setFieldsShow();
  }, [activeTabPrescription]);
  const setFieldStatus = () => {
    if (activeTabPrescription == tabKeys.GLASSES.LIST_2) {
      expandRef?.current?.setFieldValue("status", TT_DON_KINH.DA_BAN);
    }
    if (activeTabPrescription == tabKeys.GLASSES.LIST_1) {
      expandRef?.current?.setFieldValue("status", TT_DON_KINH.CHUA_BAN);
    }
  };
  useEffect(() => {
    setFieldStatus();
  }, [activeTabPrescription]);

  const onClickSearchButton = () => {
    var searchFields = expandRef?.current?.getData();
    dispatch(
      setSearchForm({
        ...searchFields,
        page: 1,

        ["start"]: formatDateToString(
          searchFields["start"],
          FORMAT_TIME.dayFull
        ),
        ["end"]: formatDateToString(searchFields["end"], FORMAT_TIME.dayFull),
        ["ngayBanTu"]: formatDateToString(
          searchFields["ngayBanTu"],
          FORMAT_TIME.dayFull
        ),
        ["ngayBanDen"]: formatDateToString(
          searchFields["ngayBanDen"],
          FORMAT_TIME.dayFull
        ),
        ["ngaySinh"]: formatDateToString(
          searchFields["ngaySinh"],
          FORMAT_TIME.dayFull
        ),
      })
    );
  };
  const onChangeTabList = key => {
    dispatch(setActiveTabPresciption(key));
  };

  return (
    <div className="listPrescriptions-container">
      <div className="container">
        <ExpandSearch
          ref={expandRef}
          onClickSearch={onClickSearchButton}
          fields={inputFields}
          onReset={() => {
            setFieldStatus();
            onClickSearchButton();
          }}
        ></ExpandSearch>
      </div>
      <div className="">
        <Tabs
          activeKey={activeTabPrescription}
          onChange={onChangeTabList}
          items={items}
        />
      </div>
    </div>
  );
};

export default ListPrescription;
